var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8678 15.1065H0.623047V0.694336H20.8678L24.72 7.83609L20.8678 15.1065ZM16.6135 9.57243C17.5369 9.57243 18.2856 8.82382 18.2856 7.90035C18.2856 6.97689 17.5369 6.22827 16.6135 6.22827C15.69 6.22827 14.9414 6.97689 14.9414 7.90035C14.9414 8.82382 15.69 9.57243 16.6135 9.57243Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8678 15.1065H0.623047V0.694336H20.8678L24.72 7.83609L20.8678 15.1065ZM16.6135 9.57243C17.5369 9.57243 18.2856 8.82382 18.2856 7.90035C18.2856 6.97689 17.5369 6.22827 16.6135 6.22827C15.69 6.22827 14.9414 6.97689 14.9414 7.90035C14.9414 8.82382 15.69 9.57243 16.6135 9.57243Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.623047 15.1065H-1.37695V17.1065H0.623047V15.1065ZM20.8678 15.1065V17.1065H22.0715L22.6351 16.0428L20.8678 15.1065ZM0.623047 0.694336V-1.30566H-1.37695V0.694336H0.623047ZM20.8678 0.694336L22.6281 -0.255129L22.0615 -1.30566H20.8678V0.694336ZM24.72 7.83609L26.4873 8.77247L26.9879 7.82768L26.4803 6.88663L24.72 7.83609ZM0.623047 17.1065H20.8678V13.1065H0.623047V17.1065ZM-1.37695 0.694336V15.1065H2.62305V0.694336H-1.37695ZM20.8678 -1.30566H0.623047V2.69434H20.8678V-1.30566ZM26.4803 6.88663L22.6281 -0.255129L19.1076 1.6438L22.9598 8.78556L26.4803 6.88663ZM22.6351 16.0428L26.4873 8.77247L22.9528 6.89972L19.1006 14.1701L22.6351 16.0428ZM16.2856 7.90035C16.2856 7.71925 16.4324 7.57243 16.6135 7.57243V11.5724C18.6415 11.5724 20.2856 9.92838 20.2856 7.90035H16.2856ZM16.6135 8.22827C16.4324 8.22827 16.2856 8.08146 16.2856 7.90035H20.2856C20.2856 5.87232 18.6415 4.22827 16.6135 4.22827V8.22827ZM16.9414 7.90035C16.9414 8.08146 16.7946 8.22827 16.6135 8.22827V4.22827C14.5855 4.22827 12.9414 5.87232 12.9414 7.90035H16.9414ZM16.6135 7.57243C16.7946 7.57243 16.9414 7.71925 16.9414 7.90035H12.9414C12.9414 9.92838 14.5855 11.5724 16.6135 11.5724V7.57243Z",
    fill: "#333333",
    mask: "url(#path-1-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/TagIcon.e7b5a614fdca8767e893dfd1975e634b.svg";
export { ForwardRef as ReactComponent };